import React from 'react';

import DateRatingWidget from './DateRatingWidget';
import { SPARK_URL } from './apiConfig';

export default function DatesView({
  dateBookings, archivedDateBookings, showArchivedDates, setShowArchivedDates,
  matches, profile, user, error,
  onAcceptDate, onDeclineDate, onCancelDate, onConfirmBooking,
  onArchiveDateBooking, onUnarchiveDateBooking,
  onLoadAllDateBookings,
  setSelectedMatch, setShowDateModal, setCounterProposalBooking,
}) {
  return (
  <div className="fade-in" style={{ padding: '20px' }}>
    {/* Active/Archived toggle is owned by the parent DatePlannerView so the
        toggle appears once in the header — was duplicated here previously
        (the "MOVED TO TOP" comment was a leftover from when DatesView was
        the standalone view). Removed 3 May 2026 per JEzza UX feedback. */}

    <h3 style={{
      fontSize: '24px',
      fontWeight: 700,
      marginBottom: '8px',
      color: '#2c3e50'
    }}>
      Your Dates
    </h3>
    <p style={{
      color: '#7f8c8d',
      marginBottom: '16px',
      fontSize: '14px'
    }}>
      Manage your date proposals
    </p>

    {(() => {
      const displayDates = showArchivedDates ? archivedDateBookings : dateBookings;
      
      const filteredDates = displayDates.filter(b => {
        if (showArchivedDates) return true; // Show all archived
        // Active: exclude cancelled/declined unless needing acknowledgment
        if (b.status === 'cancelled') {
          return b.cancellationInfo && !b.cancellationInfo.acknowledgedBy;
        }
        if (b.status === 'declined') {
          return b.declineInfo && !b.declineInfo.acknowledgedBy;
        }
        return ['pending', 'accepted', 'suggest_changes', 'completed'].includes(b.status);
      });

      return filteredDates.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          color: '#95a5a6'
        }}>
          <span style={{ fontSize: '48px', marginBottom: '16px', display: 'block' }}>📅</span>
          <p>{showArchivedDates ? 'No archived dates' : 'No dates yet. Start by messaging your matches!'}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {filteredDates
            
          .map(booking => {
          const isPending = booking.status === 'pending';
          const isAccepted = booking.status === 'accepted';
          const isDeclined = booking.status === 'declined';
          const isCancelled = booking.status === 'cancelled';
          const isCompleted = booking.status === 'completed';
          const hasChanges = booking.status === 'suggest_changes';
          const iAmProposer = booking.proposedBy === user.id;
          const iAmReceiver = booking.proposedTo === user.id;

          return (
            <div key={booking._id} style={{
              background: 'white',
              border: '2px solid',
              borderColor: isCompleted ? '#9b59b6' : isAccepted ? '#51cf66' : isPending ? '#667eea' : hasChanges ? '#ffa500' : isDeclined ? '#ff6b6b' : isCancelled ? '#e9ecef' : '#e9ecef',
              borderRadius: '16px',
              padding: '20px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
            }}>
              {/* Status Badge */}
              <div style={{
                display: 'inline-block',
                padding: '6px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 600,
                marginBottom: '12px',
                background: isCompleted ? '#9b59b6' : isAccepted ? '#51cf66' : isPending ? '#667eea' : hasChanges ? '#ffa500' : isDeclined ? '#ff6b6b' : isCancelled ? '#e9ecef' : '#e9ecef',
                color: (isCompleted || isAccepted || isPending || hasChanges || isDeclined) ? 'white' : '#7f8c8d'
              }}>
                {isCompleted && '✅ Completed'}
                {isAccepted && '✅ Accepted'}
                {isPending && (iAmReceiver ? '⏳ Awaiting Your Response' : '⏳ Awaiting Response')}
                {hasChanges && (iAmProposer ? '💬 Changes Suggested' : '💬 Changes Sent')}
                {isDeclined && '❌ Declined'}
                {isCancelled && '🚫 Cancelled'}
              </div>

              {/* Match Info */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '16px',
                paddingBottom: '16px',
                borderBottom: '1px solid #e9ecef'
              }}>
                <img
                  src={booking.matchUser?.photos?.[0]?.url || 'https://via.placeholder.com/50'}
                  alt={booking.matchUser?.firstName}
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                />
                <div style={{ flex: 1 }}>
                  <h4 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
                    Date with {booking.matchUser?.firstName}
                  </h4>
                  <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#7f8c8d' }}>
                    {iAmProposer ? 'You proposed this date' : `${booking.matchUser?.firstName} proposed this date`}
                  </p>
                </div>
              </div>

              {/* Date Details */}
              <div style={{ marginBottom: '16px' }}>
                <div style={{
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#2c3e50',
                  marginBottom: '8px'
                }}>
                  📍 {booking.venue?.name}
                </div>
                <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '4px' }}>
                  {booking.venue?.address}
                </div>
                <div style={{ fontSize: '14px', color: '#2c3e50', marginTop: '8px' }}>
                  🗓️ {new Date(booking.proposedDateTime).toLocaleString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                  })}
                </div>
              </div>

              {/* Date Logistics - IMPROVED LAYOUT */}
              {booking.notes && (
                <div style={{
                  background: '#f8f9fa',
                  padding: '16px',
                  borderRadius: '12px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    marginBottom: '12px',
                    color: '#2c3e50'
                  }}>
                    📋 Date Details
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#2c3e50',
                    whiteSpace: 'pre-line',
                    lineHeight: '1.8'
                  }}>
                    {booking.notes}
                  </div>
                </div>
              )}

              {/* Suggested Changes Display */}
              {hasChanges && booking.suggestedChanges && (
                <div style={{
                  background: '#fff3cd',
                  border: '2px solid #ffa500',
                  padding: '16px',
                  borderRadius: '12px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    fontSize: '15px',
                    fontWeight: 700,
                    marginBottom: '12px',
                    color: '#2c3e50'
                  }}>
                    💬 {iAmProposer 
                      ? `${booking.matchUser?.firstName} is keen for the date but has a couple of changes to suggest`
                      : 'Your suggested changes have been sent'}
                  </div>

                  {/* Show proposed changes as a comparison */}
                  {booking.suggestedChanges.proposedDate && (
                    <div style={{ display:'flex', flexDirection:'column', gap:'10px', marginBottom:'12px' }}>
                      {/* Venue change */}
                      {booking.suggestedChanges.proposedDate.venue?.name !== booking.venue?.name && (
                        <div style={{ background:'white', borderRadius:'10px', padding:'12px' }}>
                          <div style={{ fontSize:'12px', fontWeight:600, color:'#856404', marginBottom:'6px' }}>📍 Venue</div>
                          <div style={{ display:'flex', alignItems:'center', gap:'8px', fontSize:'13px' }}>
                            <span style={{ color:'#999', textDecoration:'line-through' }}>{booking.venue?.name}</span>
                            <span style={{ color:'#2c3e50' }}>→</span>
                            <span style={{ color:'#2c3e50', fontWeight:600 }}>{booking.suggestedChanges.proposedDate.venue?.name}</span>
                          </div>
                        </div>
                      )}
                      {/* Date/Time change */}
                      {booking.suggestedChanges.proposedDate.proposedDateTime && 
                       new Date(booking.suggestedChanges.proposedDate.proposedDateTime).getTime() !== new Date(booking.proposedDateTime).getTime() && (
                        <div style={{ background:'white', borderRadius:'10px', padding:'12px' }}>
                          <div style={{ fontSize:'12px', fontWeight:600, color:'#856404', marginBottom:'6px' }}>🗓️ Date & Time</div>
                          <div style={{ display:'flex', alignItems:'center', gap:'8px', fontSize:'13px' }}>
                            <span style={{ color:'#999', textDecoration:'line-through' }}>
                              {new Date(booking.proposedDateTime).toLocaleString('en-AU', { weekday:'short', day:'numeric', month:'short', hour:'numeric', minute:'2-digit' })}
                            </span>
                            <span style={{ color:'#2c3e50' }}>→</span>
                            <span style={{ color:'#2c3e50', fontWeight:600 }}>
                              {new Date(booking.suggestedChanges.proposedDate.proposedDateTime).toLocaleString('en-AU', { weekday:'short', day:'numeric', month:'short', hour:'numeric', minute:'2-digit' })}
                            </span>
                          </div>
                        </div>
                      )}
                      {/* Notes / logistics change */}
                      {booking.suggestedChanges.proposedDate.notes && booking.suggestedChanges.proposedDate.notes !== booking.notes && (
                        <div style={{ background:'white', borderRadius:'10px', padding:'12px' }}>
                          <div style={{ fontSize:'12px', fontWeight:600, color:'#856404', marginBottom:'6px' }}>📋 Details</div>
                          <div style={{ fontSize:'13px', color:'#2c3e50', whiteSpace:'pre-line', lineHeight:'1.5' }}>
                            {booking.suggestedChanges.proposedDate.notes}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Fallback: show text-only changes if no structured data */}
                  {!booking.suggestedChanges.proposedDate && booking.suggestedChanges.changes && (
                    <div style={{
                      fontSize: '12px',
                      color: '#2c3e50',
                      whiteSpace: 'pre-line',
                      lineHeight: '1.6'
                    }}>
                      {booking.suggestedChanges.changes}
                    </div>
                  )}

                  {/* Accept / Decline changes buttons for proposer */}
                  {iAmProposer && (
                    <div style={{ display:'flex', gap:'8px', marginTop:'12px' }}>
                      <button
                        onClick={async () => {
                          try {
                            const token = localStorage.getItem('accessToken');
                            await fetch(`${SPARK_URL}/dates/${booking._id}/accept-changes`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
                            });
                            alert('✅ Changes accepted! Date updated.');
                            onLoadAllDateBookings(token, matches);
                          } catch (err) { console.error('Error accepting changes:', err); }
                        }}
                        style={{ flex:1, padding:'12px', background:'#51cf66', color:'white', border:'none', borderRadius:'10px', fontSize:'14px', fontWeight:600, cursor:'pointer' }}>
                        ✅ Accept Changes
                      </button>
                      <button
                        onClick={async () => {
                          try {
                            const token = localStorage.getItem('accessToken');
                            await fetch(`${SPARK_URL}/dates/${booking._id}/decline-changes`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
                            });
                            alert('Changes declined — date reverts to your original plan.');
                            onLoadAllDateBookings(token, matches);
                          } catch (err) { console.error('Error declining changes:', err); }
                        }}
                        style={{ flex:1, padding:'12px', background:'#e9ecef', color:'#7f8c8d', border:'none', borderRadius:'10px', fontSize:'14px', fontWeight:600, cursor:'pointer' }}>
                        Keep Original
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* Decline Reason Display */}
              {isDeclined && booking.declineInfo && !booking.declineInfo.acknowledgedBy && (
                <div style={{
                  background: '#fee',
                  border: '2px solid #ff6b6b',
                  padding: '16px',
                  borderRadius: '12px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    marginBottom: '8px',
                    color: '#2c3e50'
                  }}>
                    ❌ Date Declined
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#2c3e50',
                    marginBottom: '12px',
                    lineHeight: '1.6'
                  }}>
                    {booking.matchUser?.firstName} declined: "{booking.declineInfo.reason}"
                  </div>
                  <button
                    onClick={async () => {
                      try {
                        const token = localStorage.getItem('accessToken');
                        await fetch(`${SPARK_URL}/dates/${booking._id}/acknowledge`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                          },
                          body: JSON.stringify({ type: 'decline' })
                        });
                        onLoadAllDateBookings(token, matches);
                      } catch (err) {
                        console.error('Error acknowledging:', err);
                      }
                    }}
                    style={{
                      padding: '10px 16px',
                      background: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    Okay, I understand
                  </button>
                </div>
              )}

              {/* Cancellation Reason Display */}
              {isCancelled && booking.cancellationInfo && !booking.cancellationInfo.acknowledgedBy && (
                <div style={{
                  background: '#fee',
                  border: '2px solid #ff6b6b',
                  padding: '16px',
                  borderRadius: '12px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    marginBottom: '8px',
                    color: '#2c3e50'
                  }}>
                    🚫 Date Cancelled
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#2c3e50',
                    marginBottom: '12px',
                    lineHeight: '1.6'
                  }}>
                    {booking.matchUser?.firstName} cancelled: "{booking.cancellationInfo.reason}"
                  </div>
                  <button
                    onClick={async () => {
                      try {
                        const token = localStorage.getItem('accessToken');
                        await fetch(`${SPARK_URL}/dates/${booking._id}/acknowledge`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                          },
                          body: JSON.stringify({ type: 'cancellation' })
                        });
                        onLoadAllDateBookings(token, matches);
                      } catch (err) {
                        console.error('Error acknowledging:', err);
                      }
                    }}
                    style={{
                      padding: '10px 16px',
                      background: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    Okay, I understand
                  </button>
                </div>
              )}

              {/* Feedback/Rating Section */}
              {isCompleted && (
                <div style={{
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                  padding: '16px',
                  borderRadius: '12px',
                  marginBottom: '16px'
                }}>
                  {!booking.feedback?.find(f => f.userId === user.id) ? (
                    <DateRatingWidget 
                      booking={booking} 
                      matchFirstName={booking.matchUser?.firstName}
                      onSubmit={async (rating, venueRating, pricePerPerson, comment) => {
                        try {
                          const token = localStorage.getItem('accessToken');
                          // Submit feedback
                          const fbRes = await fetch(`${SPARK_URL}/dates/${booking._id}/feedback`, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                              'Authorization': `Bearer ${token}`
                            },
                            body: JSON.stringify({ rating, venueRating, pricePerPerson, comment: comment || '' })
                          });
                          const fbData = await fbRes.json();
                          if (!fbData.success) {
                            alert('Failed: ' + fbData.message);
                            return;
                          }
                          // Auto-archive after rating
                          await fetch(`${SPARK_URL}/dates/${booking._id}/archive`, {
                            method: 'POST',
                            headers: { 'Authorization': `Bearer ${token}` }
                          });
                          onLoadAllDateBookings(token, matches);
                        } catch (err) {
                          console.error('Feedback error:', err);
                          alert('Failed to submit feedback');
                        }
                      }}
                    />
                  ) : (
                    (() => {
                      const myFeedback = booking.feedback.find(f => f.userId === user.id);
                      return (
                        <div>
                          <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '6px', color: '#2c3e50' }}>
                            ✅ Your Rating: {'⭐'.repeat(myFeedback.rating)}
                          </div>
                          {myFeedback.venueRating && (
                            typeof myFeedback.venueRating === 'number' ? (
                              <div style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
                                📍 Venue: {'⭐'.repeat(myFeedback.venueRating)}
                              </div>
                            ) : (
                              Object.entries(myFeedback.venueRating).map(([venue, stars]) => (
                                <div key={venue} style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
                                  📍 {venue}: {'⭐'.repeat(stars)}
                                </div>
                              ))
                            )
                          )}
                          {myFeedback.pricePerPerson && (
                            <div style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
                              💰 Spend: {myFeedback.pricePerPerson === 'free' ? 'Free' : `$${myFeedback.pricePerPerson}`} per person
                            </div>
                          )}
                          {myFeedback.comment && (
                            <div style={{
                              fontSize: '12px',
                              color: '#7f8c8d',
                              fontStyle: 'italic',
                              marginTop: '6px'
                            }}>
                              "{myFeedback.comment}"
                            </div>
                          )}
                        </div>
                      );
                    })()
                  )}
                </div>
              )}

              {/* Action Buttons */}
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {/* Pending date actions */}
                {isPending && iAmReceiver && (
                  <>
                    <button
                      onClick={() => onAcceptDate(booking._id)}
                      style={{
                        flex: 1,
                        minWidth: '100px',
                        padding: '12px',
                        background: '#51cf66',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      ✅ Accept
                    </button>
                    <button
                      onClick={() => {
                        // Find the match for this booking so modal has correct matchId
                        const bookingMatch = matches.find(m => m.matchId === booking.matchId);
                        if (bookingMatch) {
                          setSelectedMatch(bookingMatch);
                          setCounterProposalBooking(booking);
                          setShowDateModal(true);
                        }
                      }}
                      style={{
                        flex: 1,
                        minWidth: '100px',
                        padding: '12px',
                        background: '#ffa500',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      💬 Changes
                    </button>
                    <button
                      onClick={() => {
                        const reason = prompt('Please provide a reason for declining:');
                        if (reason && reason.trim()) {
                          onDeclineDate(booking._id, reason);
                        }
                      }}
                      style={{
                        flex: 1,
                        minWidth: '100px',
                        padding: '12px',
                        background: '#ff6b6b',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      ❌ Decline
                    </button>
                  </>
                )}

                {/* Accepted date actions */}
                {isAccepted && (
                  <>
                    {/* Booking Reminder Card */}
                    {(booking.bookingStatus === 'needs_booking' || 
                      (!booking.bookingStatus && booking.venue?.name?.toLowerCase().match(/restaurant|cafe|bar|class|workshop|escape|bowling|cinema/))) && (
                      <div style={{
                        background: 'linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%)',
                        border: '2px solid #ffc107',
                        padding: '16px',
                        borderRadius: '12px',
                        marginBottom: '12px',
                        width: '100%',
                        boxSizing: 'border-box'
                      }}>
                        <div style={{ fontSize: '14px', fontWeight: 700, color: '#856404', marginBottom: '8px' }}>
                          📞 Booking Reminder
                        </div>
                        <div style={{ fontSize: '12px', color: '#856404', marginBottom: '12px', lineHeight: '1.5' }}>
                          {iAmProposer 
                            ? `Don't forget to book your table/spot at ${booking.venue?.name}! Once booked, tap "Confirm Booking" below.`
                            : `${booking.matchUser?.firstName} will handle the booking at ${booking.venue?.name}. You'll be notified once it's confirmed.`}
                        </div>
                        
                        {/* Booking links */}
                        {booking.bookingLinks?.length > 0 && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                            {booking.bookingLinks.map((link, i) => (
                              <div key={i} style={{ display: 'flex', gap: '6px' }}>
                                {link.websiteUrl && (
                                  <a href={link.websiteUrl} target="_blank" rel="noopener noreferrer"
                                    style={{ padding: '8px 14px', background: '#667eea', color: 'white', borderRadius: '8px', fontSize: '12px', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                    🌐 {link.venueName || 'Website'}
                                  </a>
                                )}
                                {link.phoneNumber && (
                                  <a href={`tel:${link.phoneNumber}`}
                                    style={{ padding: '8px 14px', background: '#51cf66', color: 'white', borderRadius: '8px', fontSize: '12px', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                    📞 Call
                                  </a>
                                )}
                                {link.googleMapsUrl && (
                                  <a href={link.googleMapsUrl} target="_blank" rel="noopener noreferrer"
                                    style={{ padding: '8px 14px', background: '#ff6b6b', color: 'white', borderRadius: '8px', fontSize: '12px', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                    📍 Maps
                                  </a>
                                )}
                              </div>
                            ))}
                          </div>
                        )}

                        {/* If no booking links from backend, show Google search link */}
                        {(!booking.bookingLinks || booking.bookingLinks.length === 0) && (
                          <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(booking.venue?.name + ' ' + (booking.venue?.address || ''))}`}
                            target="_blank" rel="noopener noreferrer"
                            style={{ display: 'inline-block', padding: '8px 14px', background: '#667eea', color: 'white', borderRadius: '8px', fontSize: '12px', fontWeight: 600, textDecoration: 'none', marginBottom: '12px' }}>
                            📍 Find on Google Maps
                          </a>
                        )}

                        {/* Confirm Booking button - only for proposer */}
                        {iAmProposer && (
                          <button
                            onClick={() => {
                              const note = prompt('Any booking confirmation details? (e.g., "Table for 2 at 7pm, ref #1234")');
                              if (note !== null) {
                                onConfirmBooking(booking._id, note || 'Booking confirmed', '');
                              }
                            }}
                            style={{
                              width: '100%', padding: '12px', background: '#51cf66', color: 'white',
                              border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: 600, cursor: 'pointer'
                            }}>
                            ✅ Confirm Booking
                          </button>
                        )}
                      </div>
                    )}

                    {/* Booking Confirmed Card */}
                    {booking.bookingStatus === 'booked' && booking.bookingInfo && (
                      <div style={{
                        background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
                        border: '2px solid #28a745',
                        padding: '16px',
                        borderRadius: '12px',
                        marginBottom: '12px',
                        width: '100%',
                        boxSizing: 'border-box'
                      }}>
                        <div style={{ fontSize: '14px', fontWeight: 700, color: '#155724', marginBottom: '6px' }}>
                          ✅ Booking Confirmed
                        </div>
                        <div style={{ fontSize: '12px', color: '#155724', lineHeight: '1.5' }}>
                          {booking.bookingInfo.confirmationNote}
                          {booking.bookingInfo.bookingReference && (
                            <span style={{ display: 'block', marginTop: '4px', fontWeight: 600 }}>
                              Ref: {booking.bookingInfo.bookingReference}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    <button
                      onClick={async () => {
                        try {
                          const token = localStorage.getItem('accessToken');
                          const response = await fetch(`${SPARK_URL}/dates/${booking._id}/complete`, {
                            method: 'POST',
                            headers: {
                              'Authorization': `Bearer ${token}`
                            }
                          });
                          const data = await response.json();
                          if (data.success) {
                            onLoadAllDateBookings(token, matches);
                          }
                        } catch (err) {
                          console.error('Error:', err);
                        }
                      }}
                      style={{
                        padding: '12px 20px',
                        background: '#9b59b6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      ✅ Mark as Completed
                    </button>
                    <button
                      onClick={() => {
                        const reason = prompt('Please provide a reason for cancellation:');
                        if (reason && reason.trim()) {
                          onCancelDate(booking._id, reason);
                        }
                      }}
                      style={{
                        padding: '12px 20px',
                        background: '#e9ecef',
                        color: '#7f8c8d',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      🚫 Cancel
                    </button>
                  </>
                )}

                {/* Pending cancellation (can still cancel before acknowledged) */}
                {isPending && iAmProposer && (
                  <button
                    onClick={() => {
                      const reason = prompt('Please provide a reason for cancellation:');
                      if (reason && reason.trim()) {
                        onCancelDate(booking._id, reason);
                      }
                    }}
                    style={{
                      padding: '12px 20px',
                      background: '#e9ecef',
                      color: '#7f8c8d',
                      border: 'none',
                      borderRadius: '10px',
                      fontSize: '14px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    🚫 Cancel Proposal
                  </button>
                )}
              </div>

              {/* Archive/Unarchive Button */}
              {showArchivedDates ? (
                <button
                  onClick={() => onUnarchiveDateBooking(booking._id)}
                  style={{
                    marginTop: '16px',
                    padding: '10px 20px',
                    background: '#e3f2fd',
                    color: '#2196f3',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    width: '100%'
                  }}
                >
                  Unarchive Date
                </button>
              ) : (
                (isCompleted || isDeclined || isCancelled) && (
                  <button
                    onClick={() => onArchiveDateBooking(booking._id)}
                    style={{
                      marginTop: '16px',
                      padding: '10px 20px',
                      background: '#f8f9fa',
                      color: '#7f8c8d',
                      border: '1px solid #e9ecef',
                      borderRadius: '10px',
                      fontSize: '14px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      width: '100%'
                    }}
                  >
                    📦 Archive Date
                  </button>
                )
              )}
            </div>
          );
        })}
      </div>
      );
    })()}
  </div>
  );
}
